import { gql } from '@apollo/client';

export const BERUFE_BY_STANDORTGRUPPEN_ID = gql(`
  query rotationsplan_berufeByStandortgruppenId($standortGruppenId: String!) {
   mitarbeiter_standortgruppeById(standortGruppenId: $standortGruppenId){
    berufe {
      id
      abkuerzung
      istAusbildung
      markierung
      name
    }
   }
  }
`);
